import { useState, ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

const Image = styled.img<{ opacity: number }>`
	transition: opacity 800ms ease-in-out;
	opacity: ${({ opacity }) => opacity};
`;

export const LazyImage = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	const [opacity, setOpacity] = useState(0);

	const onLoad = () => setOpacity(1);

	return <Image {...props} loading="lazy" onLoad={onLoad} opacity={opacity} />;
};
